import * as nodeUtils from "../../../abstract/controller/utils/nodeUtils";
import styles from "./ReadOnlyParameterMain.module.scss";

function ReadOnlyParameterMain({ node, children, isFolded }) {
  const _isLinked = nodeUtils.isParameterLinked(node.current);

  const getClassFold = () => {
    return isFolded ? styles["position--folded"] : styles["position--unfolded"];
  };

  const getClass = () => {
    return `${styles["position"]} ${styles["style--default"]} ${getClassFold()}`;
  };

  // Show legend only when linked AND not folded
  const shouldShowLegend = _isLinked && !isFolded;

  return (
    <div className={getClass()}>
      {shouldShowLegend && <div className={styles["legend"]}>Linked</div>}
      {children}
    </div>
  );
}

export default ReadOnlyParameterMain;
